import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import apiCall from "../../API/API";

const ChangeUserRole = ({ user }) => {
  const [userId, setUserId] = useState(user?.uid);
  const [username, setUsername] = useState(user?.username);
  const [password, setPassword] = useState("");
  const [roles, setRoles] = useState(user?.roles || []);

  const handleRoleChange = (role) => {
    if (roles.includes(role)) {
      setRoles(roles.filter((r) => r !== role));
    } else {
      setRoles([...roles, role]);
    }
  };

  const handleSubmit = async () => {
    try {
      const body = {
        username,
        password,
        roles,
      };
      console.log("body =====>", body);
      const response = await apiCall("POST", "/update-user-role", body);
      if (response?.data?.success) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.error?.message);
      }
    } catch (e) {
      toast.error(e?.response?.data?.message);
    }
  };

  return (
    <React.Fragment>
      <Container>
        <section className="formItems">
          <h3 style={{ textAlign: "center" }} className="mb-4">
            Update User Role
          </h3>
          <div className="form">
            <Row>
              <Col lg="2"></Col>
              <Col lg="8">
                <form onSubmit={(e) => e.preventDefault()} className="registerForm">
                  <div>
                    <label>Username</label>
                    <input type="text" value={username} readOnly />
                  </div>
                  <div>
                    <label>{user?.isPassword ? "Update Password (optional)" : "Set Password*"}</label>
                    <input
                      type="text"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder={user?.isPassword ? "Leave blank to keep current password" : "Enter new password"}
                      required={!user?.isPassword}
                    />
                  </div>
                  <div>
                    <label>Roles</label>
                    <div style={{ display: "flex", gap: "20px" }}>
                      {["user", "manager", "admin"].map((role) => (
                        <label key={role}>
                          <input
                            type="checkbox"
                            checked={roles.includes(role)}
                            onChange={() => handleRoleChange(role)}
                          />
                          {role.charAt(0).toUpperCase() + role.slice(1)}
                        </label>
                      ))}
                    </div>
                  </div>
                  <Button onClick={handleSubmit} className="save">
                    Update
                  </Button>
                </form>
              </Col>
            </Row>
          </div>
        </section>
      </Container>
      <ToastContainer className="toast-container" />
    </React.Fragment>
  );
};


export default ChangeUserRole;
